import { render } from "./DefaultPage.vue?vue&type=template&id=fba84c7a&scoped=true"
import script from "./DefaultPage.vue?vue&type=script&lang=js"
export * from "./DefaultPage.vue?vue&type=script&lang=js"

import "./DefaultPage.vue?vue&type=style&index=0&id=fba84c7a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba84c7a"]])

export default __exports__